import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CertGenParams, CertificateData } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { CertGenExpandedParams } from 'common.components/certificates-expanded-params-modal/typings';

import { TeacherCertificatesStoreState } from './typings';

const initialState: TeacherCertificatesStoreState = {
    readyCertificates: [],
    readyCertificatesLoadingStatus: LOADING_STATUSES.UNSENT,
    certificatesParamsLoadingStatus: LOADING_STATUSES.UNSENT,
    postCertExpandedParamsLoadingStatus: LOADING_STATUSES.UNSENT,
};

const slice = createSlice({
    name: 'TEACHER_PORTFOLIO',
    initialState: initialState,
    reducers: {
        getReadyCertificatesRequest: (state: TeacherCertificatesStoreState) => {
            state.readyCertificatesLoadingStatus = LOADING_STATUSES.LOADING;
        },
        setReadyCertificates: (state: TeacherCertificatesStoreState, action: PayloadAction<CertificateData[]>) => {
            const certificates = action.payload;

            state.readyCertificatesLoadingStatus = LOADING_STATUSES.SUCCESS;
            state.readyCertificates = certificates;
        },
        reportReadyCertificatesError: (state: TeacherCertificatesStoreState) => {
            state.readyCertificatesLoadingStatus = LOADING_STATUSES.ERROR;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        setCertificatesParamsRequest: (state: TeacherCertificatesStoreState, action: PayloadAction<CertGenParams>) => {
            state.certificatesParamsLoadingStatus = LOADING_STATUSES.LOADING;
        },
        setCertificatesParamsSuccess: (state: TeacherCertificatesStoreState) => {
            state.certificatesParamsLoadingStatus = LOADING_STATUSES.SUCCESS;
        },
        setCertificatesParamsError: (state: TeacherCertificatesStoreState) => {
            state.certificatesParamsLoadingStatus = LOADING_STATUSES.ERROR;
        },
        postCertExpandedParamsRequest: (
            state: TeacherCertificatesStoreState,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            action: PayloadAction<CertGenExpandedParams>
        ) => {
            state.postCertExpandedParamsLoadingStatus = LOADING_STATUSES.LOADING;
        },
        postCertExpandedParamsSuccess: (state: TeacherCertificatesStoreState) => {
            state.postCertExpandedParamsLoadingStatus = LOADING_STATUSES.SUCCESS;
        },
        postCertExpandedParamsError: (state: TeacherCertificatesStoreState) => {
            state.postCertExpandedParamsLoadingStatus = LOADING_STATUSES.ERROR;
        },
    },
});

export const actions = slice.actions;
export const teacherOpenCertificatesReducer = slice.reducer;
